/**
 * fieldType.ts
 * Field-Type catalog operations (sk-catalog-api  GET /api/v1/field-types)
 *
 * Returns the DB-backed field-type catalog exactly as the backend provides it.
 * Cached for the session so the wizard, settings panel and editor share a single
 * network request.
 */
import axiosInstance from '../../api/axiosInstance';
import { Catalog_FieldTypes_Url } from '../../api/endpoints';
import type { FieldTypeDef, FieldTypesResponse } from '../../schemas/catalog/fieldType';

// Session cache of the in-flight / resolved request. Failures are NOT cached,
// so a transient error doesn't permanently block a retry.
let cache: Promise<FieldTypeDef[]> | null = null;

export const getFieldTypes = (): Promise<FieldTypeDef[]> => {
  if (!cache) {
    cache = axiosInstance
      .get<FieldTypesResponse>(Catalog_FieldTypes_Url)
      .then(({ data }) => {
        const items = data.items ?? [];
        return [...items].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
      })
      .catch((err) => {
        cache = null; // allow a retry on next call
        throw err;
      });
  }
  return cache;
};

/** Drop the cache so the next getFieldTypes() re-fetches (e.g. after an admin edit). */
export const invalidateFieldTypes = (): void => {
  cache = null;
};
